import Api from '../../shared/Api';
import ICalendar from '../calendar/ICalendar';

export default class PhotographerCalendarApi {
    static getPhotographerOverview(
        year: number,
        month: number,
        day: number,
        streetAddress: string,
        postalCode: string,
        city: string,
        userSite: number
    ) {
        let query = '';
        let c = '?';
        let params = {
            year: year,
            month: month,
            day: day,
            streetAddress: streetAddress,
            postalCode: postalCode,
            city: city,
            userSite: userSite
        };
        for (let key in params) {
            query += `${c}${key}=${params[key]}`;
            c = '&';
        }

        return new Api().get(`/views/photographers/overview${query}`);
    }
}
